module.exports = __webpack_public_path__ + "img/profpereklad.e1869d5c.png";